import { motion, useReducedMotion } from "framer-motion";
import { EASE, Eyebrow, FadeUp } from "../Reveal";
import { LuxButton } from "../LuxButton";
import { IMG } from "@/lib/images";

const POINTS = [
  "Seamless request management",
  "Dedicated support for every need",
  "Proactive problem solving",
];

export const LifestyleSplit = () => {
  const reduced = useReducedMotion();
  return (
    <section data-testid="lifestyle-section" className="grid lg:grid-cols-2">
      <div className="relative min-h-[380px] overflow-hidden sm:min-h-[460px] lg:min-h-[660px]" data-cursor>
        <motion.img
          src={IMG.lifestyle}
          alt="Riviera resort palms against a violet dusk sky"
          loading="lazy"
          initial={reduced ? { opacity: 0 } : { scale: 1.06, opacity: 0.6 }}
          whileInView={reduced ? { opacity: 1 } : { scale: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.4, ease: EASE }}
          className="img-lux-grade absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#080808]/30" />
      </div>

      <div className="flex flex-col justify-center bg-[#080808] px-6 py-20 sm:px-12 lg:px-20 lg:py-32">
        <FadeUp>
          <Eyebrow>Service</Eyebrow>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mt-6 max-w-md font-serif text-[34px] font-medium leading-[1.1] text-ivory sm:text-4xl lg:text-[46px]">
            Built around your <span className="gold-text italic">lifestyle</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-ivory-muted">
            We handle the details so you can focus on what matters. Fast,
            discreet, expert support — always.
          </p>
        </FadeUp>
        <FadeUp delay={0.3}>
          <ul className="mt-8 space-y-3.5">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-4 text-[13px] font-light text-ivory-muted">
                <span className="h-[5px] w-[5px] rotate-45 bg-champagne/90" aria-hidden="true" />
                {p}
              </li>
            ))}
          </ul>
        </FadeUp>
        <FadeUp delay={0.4} className="mt-10 flex flex-wrap items-center gap-4">
          <LuxButton to="/concierge" testId="lifestyle-discover-button">
            Discover
          </LuxButton>
          <LuxButton variant="text" arrow to="/about" testId="lifestyle-learn-more-button">
            Learn More
          </LuxButton>
        </FadeUp>
      </div>
    </section>
  );
};
